import axios from 'axios';
import {AxiosError} from "axios";

// import dayjs from "dayjs";
// import qs from 'qs';
//
// axios.interceptors.request.use((config) => {
//     config.paramsSerializer = (params) => qs.stringify(params, {
//         serializeDate: (date: Date) => dayjs(date).format('YYYY-MM-DD') });
//     return config;
// })

function isAxiosError(error: unknown): error is AxiosError {
    return (error as AxiosError).isAxiosError !== undefined;
}

const getAuth = (): string  => {
    let token = localStorage.getItem("token");
    if (!token) {
        token = ""
    }

    return  "Bearer " + token
}
export async function get<T>(
    path: string,
    params?: {[key: string]: string},
    onError?: (error: any) => void
): Promise<T> {
    let query = "";
    if (params) {
        const urlParams = new URLSearchParams(params);
        query = `?${urlParams.toString()}`;
    }
    try {
        const { data } = await axios.get(path + query, {
            headers: {
                Authorization: getAuth(),
            },
        });
        return data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 401 && onError) {
            onError(error);
        }
        throw error;
    }
}


export async function post<T>(path: string, json: any, state_id?: number):
    
    Promise<T> {

    // get state from query params
    const urlParams = new URLSearchParams(window.location.search);
    let state = urlParams.get("state");

    if (state_id) {
        state = state_id.toString();
    }
 
    // check if json has state_id and if replace with number. Treat json as any type to avoid type error
    if (state && json.hasOwnProperty("state_id")) {
        json["state_id"] = Number(state)
    }


    const {data} = await axios.post(path, json,
        {
            headers: {
                Authorization: getAuth()
            }
        });
    return data;
}

export async function put<T>(path: string, json: T):
    Promise<T> {
    const {data} = await axios.put(path, json,
        {
            headers: {
                Authorization: getAuth()
            }
        });
    return data;
}

export async function postv2<T, RT>(path: string, json: T):
    Promise<RT> {
    const {data} = await axios.post(path, json,
        {
            headers: {
                Authorization: getAuth()
            }
        });
    return data;
}

export async function del<T>(path: string):
    Promise<T> {
    const {data} = await axios.delete(path,
        {
            headers: {
                Authorization: getAuth()
            }
        });
    return data;
}



export async function login<T>(path: string, json: T):
    Promise<T> {
    const {data} = await axios.post(path, json,
        {
        });
    return data;
}


export async function download(path: string): Promise<{ data: Blob, filename: string }> {
    try {
        const response = await axios.get(path,
            {
                headers: {
                    Authorization: getAuth()

                },
                responseType: 'blob'
            });
        // get filename from Content-Disposition header
        let filename = 'file';
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(contentDisposition);
            if (matches !== null && matches[1]) {
                filename = matches[1].replace(/['"]/g, '');
            }
        }

        return { data: response.data, filename };
    } catch (error) {
        if (isAxiosError(error) && error.response) {
            // Check if the response is a Blob (due to responseType: 'blob')
            if (error.response.data instanceof Blob) {

                const errorText = await error.response.data.text();
                try {
                    // Try to parse the text to JSON
                    const errorJson = JSON.parse(errorText);
                    
                    const traceback = errorJson.traceback;

                    let errorMessage = "Error downloading file. See the error message below:\n\n"
                    errorMessage += errorJson.error;
                    // combine error message and traceback to a single string
                    if (traceback) {
                        errorMessage += "\n\n" + traceback;
                    }
                    console.error(errorMessage);
                    // show error message
                    alert(errorMessage);
                    
                    throw new Error(errorMessage);
                } catch (jsonError) {
                    // If parsing to JSON fails, fall back to a generic error message
                    console.error("An error occurred, but the error message could not be parsed.");
                    throw new Error("An error occurred while downloading the file.");
                }
            } else {
                // If the response data is not a Blob, handle as you see fit
                console.error("An unexpected error occurred.");
                throw new Error("An error occurred while downloading the file.");
            }
        } else {
            console.error(error);
            throw new Error("An error occurred while downloading the file.");
        }
    }

}



export async function upload<T>(path: string, file: T):
    Promise<T> {
    const {data} = await axios.post(path, file,
        {
            headers: {
                Authorization: "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTYxNzgzODk4OSwianRpIjoiMTkyNzZmMjctOTJhOC00ZGE3LWIzY2ItYzgzY2Q4NjkyZjZmIiwibmJmIjoxNjE3ODM4OTg5LCJ0eXBlIjoiYWNjZXNzIiwic3ViIjoxfQ.3kUM5VPQsjYQgi92lgJJFFsGIDZ1Bx35mRmNPiABAUxBnuewKjMUcPg-IVa3SBS9rtMyhMXCgowVLn511FbG_g",
                'Content-Type': 'multipart/form-data'
            }
        });
    return data;
}